import { query } from "../_generated/server";
import { v } from "convex/values";

export const getGroups = query({
  args: {},
  handler: async (ctx) => {
    const identity = await ctx.auth.getUserIdentity();
    if (!identity) {
      throw new Error("Unauthenticated call to getGroups");
    }
    
    return await ctx.db
      .query("groups")
      .withIndex("by_userId", (q) => q.eq("userId", identity.subject))
      .order("asc", "order")
      .collect();
  },
});